// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iASs","content":"styles_content__rhaj-","row":"styles_row__1wWFm","footer":"styles_footer__33oV5","phraseLength":"styles_phraseLength__3beYk"};